module.exports = __webpack_public_path__ + "d8499f8.ttf";